<template>
    <v-app-bar
      :class="scrollPosition > 0?'change_color':'transparent'"
      elevate-on-scroll
      fixed
      style="height: 64px; margin-top: 0px; transform: translateY(0px); left: 0px; right: 0px; color: white"
    >
    
    <v-icon color="white">mdi-book-open-page-variant</v-icon>
          <!-- <v-icon color="white">mdi-book-open-variant</v-icon> -->

      <!-- <svgicon class="pr-2" width="30" height="30" color="white black" icon="open-book-inverted"></svgicon> -->
      <h3 class="pl-3">Registar radova</h3>
      <v-spacer></v-spacer>
      <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          dark
          v-bind="attrs"
          v-on="on"
          outlined
         
        >
        <v-icon left>mdi-account-circle</v-icon>
          {{getUser.new_username}}
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="logout" >
          <v-list-item-title ><v-icon left>mdi-logout-variant</v-icon>Odjava</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </v-app-bar>
</template>
<script>
import "../assets/compiled-icons/open-book-inverted";
import "../assets/compiled-icons/sum-icon";
import { mapGetters } from "vuex";

export default {
  name: "AppBar",

  components: {},

  data: () => ({
    scrollPosition: null,
  }),
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    logout(){
      this.$store.dispatch('logout')
    }
  },
  computed: {
    ...mapGetters(["getRegistarData", 'hasAdminRights', 'getUser']),
  },
  mounted() {
      window.addEventListener("scroll", this.updateScroll);
  },
};
</script>